import FAVICONS from 'shared/favicons';
import {showDimmer} from 'shared/utils/dimmer';
import defineSection from '~/spa/section';
import sectionHead from '~/spa/head';

const showDimmerBeforeEnter = (to, from, next) => {
    showDimmer();
    next();
};

const CHAT_PAGE_CHILDREN = [
    {
        name: 'chatDetailPage',
        path: '',
        component: () => import(/* webpackChunkName: "chats" */ './chat_detail_page/ChatDetailPageMessages.vue'),
        props: true, meta: {name: 'messages'}
    },
    {
        name: 'chatDetailPage-members',
        path: 'members',
        component: () => import(/* webpackChunkName: "chats" */ './chat_detail_page/ChatDetailPageMembers.vue'),
        props: true,
        meta: {name: 'members'}
    },
];

export default defineSection({
    head: sectionHead({icon: FAVICONS.chats}),
    routes: [
        {
            path: '/chats/',
            component: () => import(/* webpackChunkName: "chats" */ './ChatsListPage.vue'),
            props: true,
            name: 'myChatsListPage',
        },
        {
            path: '/chats/:slug/',
            component: () => import(/* webpackChunkName: "chats" */ './chat_detail_page/ChatDetailPage.vue'),
            children: CHAT_PAGE_CHILDREN,
            props: true,
        },
        {
            path: '/questions/my/:slug/',
            component: () => import(/* webpackChunkName: "chats" */ './PollPage'),
            props: true,
            name: 'myPollDetailPage',
            beforeEnter: showDimmerBeforeEnter,
        },
        {
            path: '/questions/:slug/:chatToken?/',
            component: () => import(/* webpackChunkName: "chats" */ './PollChatPage'),
            name: 'pollChatPageWithToken',
            props: true,
        },
    ]
});
